import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen w-full overflow-hidden flex items-center justify-center" data-id="element-82">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-83">
        <motion.div initial={{
        scale: 1.1
      }} animate={{
        scale: 1
      }} transition={{
        duration: 10,
        ease: 'easeOut'
      }} className="w-full h-full bg-hero-pattern bg-cover bg-center" data-id="element-84" />
        <div className="absolute inset-0 bg-navy-900/60 mix-blend-multiply" data-id="element-85" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-transparent to-navy-900/30" data-id="element-86" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-88">
          <span className="block font-heading font-bold text-gold-500 tracking-[0.2em] uppercase mb-4 text-sm md:text-base" data-id="element-89">
            Est. 2024 • Coastal Dining
          </span>
          <h1 className="font-heading font-extrabold text-5xl md:text-7xl lg:text-8xl text-white mb-6 leading-tight" data-id="element-90">
            THE DOCK WALL
          </h1>
          <p className="font-sans text-lg md:text-2xl text-gray-200 mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-91">
            Where the untamed ocean meets the plate. Experience bold flavors and
            dramatic views in a setting defined by maritime heritage.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-92">
            <Button variant="primary" size="lg" onClick={() => document.getElementById('reservations')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-93">
              Reserve Your Table
            </Button>
            <Button variant="outline" size="lg" onClick={() => document.getElementById('menu')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-94">
              View Menu
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10" data-id="element-95">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-96">
          <ChevronDown className="text-white/50 w-8 h-8" data-id="element-97" />
        </motion.div>
      </motion.div>
    </section>;
}